import { LoadingStatesStateSchema } from "../types/loadingStatesTypes";

export const getLoadingStatesState = (state: LoadingStatesStateSchema) =>
  state.loadingStates;
